import React from "react";
import css from "./Spinner.module.css";

const SpinnerComponent = () => {
  return (
    <div className={css.aaa}>
      <span className={css.loader}></span>
    </div>
  );
};

export default SpinnerComponent;
